module.exports = __webpack_public_path__ + "7058410f8e27351fe623a962c70232d2.jpg";